/* Scroll-snap rails: prev/next buttons that step one card, disabled at the ends. */
(() => {
  if (window.__nsRail) return;
  window.__nsRail = true;
  const step = (rail, dir) => {
    const item = rail.firstElementChild;
    const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    rail.scrollBy({ left: dir * ((item?.getBoundingClientRect().width || rail.clientWidth) + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rail-prev], [data-rail-next]'); if (!b) return;
    const rail = document.getElementById(b.getAttribute('aria-controls'));
    if (rail) step(rail, b.hasAttribute('data-rail-next') ? 1 : -1);
  });
  const sync = (rail) => {
    const max = rail.scrollWidth - rail.clientWidth - 2;
    document.querySelectorAll(`[aria-controls="${rail.id}"][data-rail-prev]`).forEach((b) => (b.disabled = rail.scrollLeft <= 2));
    document.querySelectorAll(`[aria-controls="${rail.id}"][data-rail-next]`).forEach((b) => (b.disabled = rail.scrollLeft >= max));
  };
  const init = () => document.querySelectorAll('.rail[id]').forEach((rail) => {
    if (rail.dataset.railReady) return; rail.dataset.railReady = 1;
    rail.addEventListener('scroll', () => requestAnimationFrame(() => sync(rail)), { passive: true });
    rail.addEventListener('keydown', (e) => { if (e.target === rail && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { e.preventDefault(); step(rail, e.key === 'ArrowRight' ? 1 : -1); } });
    new ResizeObserver(() => sync(rail)).observe(rail);
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
